import { render, staticRenderFns } from "./CouponsReactivation.vue?vue&type=template&id=562e9839&scoped=true&"
import script from "./CouponsReactivation.vue?vue&type=script&lang=js&"
export * from "./CouponsReactivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562e9839",
  null
  
)

export default component.exports